export default ($el, keywordFieldId, modalId) => ({
  filters: [],
  selections: {},
  keywords: '',
  scoped: {},
  state: 'updating',
  resultsCount: 0,
  resultsCountLabel: 'Show Results',
  el: $el,
  keywordFieldId: keywordFieldId,
  modalId: modalId,

  init() {
    let data = this.el.getAttribute('data-available-filters');
    data = JSON.parse(data);
    let scopedData = this.el.getAttribute('data-scoped');
    scopedData = JSON.parse(scopedData);
    const availableFilters = data.split('|');
    this.selections = {};
    availableFilters.forEach(filterSlug => {
      this.selections[filterSlug] = [];
    });

    const urlParams = new URLSearchParams(window.location.search);
    for (const [key, value] of urlParams) {
      if (this.selections[key]) {
        this.selections[key] = value.split(',');
      }
    }
    this.scoped = scopedData;

    // on init, pull in the existing keyword value so we can keep track
    if (keywordFieldId) {
      this.updateKeywords(document.getElementById(keywordFieldId).value);
    }

    this.updateAllResetButtonVisibility();
    this.fetchResultsCount();

  },

  buildQueryString() {
    let queryString = Object.entries(this.selections).reduce((queryString, [key, values]) => {
      if (values.length > 0) {
        return queryString + (queryString.length > 0 ? '&' : '') + `${key}=${values.join(',')}`;
      }
      return queryString;
    }, '');

    if (this.keywords.length > 0) {
      queryString = queryString + (queryString.length > 0 ? '&' : '') + 'keywords=' + this.keywords;
    }

    return queryString;
  },


  updateSelections(filterSlug, value, event) {
    this.state = 'updating';
    if (value === 'all') {
      if (event.target.checked) {
        this.selections[filterSlug] = [];
      }
    } else {
      const allIndex = this.selections[filterSlug].indexOf('all');
      if (allIndex > -1) {
        this.selections[filterSlug].splice(allIndex, 1);
      }

      if (event.target.checked) {
        if (!this.selections[filterSlug].includes(value)) {
          this.selections[filterSlug].push(value);
        }
      } else {
        const index = this.selections[filterSlug].indexOf(value);
        if (index > -1) {
          this.selections[filterSlug].splice(index, 1);
        }
      }
    }

    this.updateResetButtonVisibility(filterSlug);
    this.fetchResultsCount();
  },

  reset(filterSlug) {
    this.selections[filterSlug] = [];
    this.updateResetButtonVisibility(filterSlug);
    this.fetchResultsCount();
    document.querySelectorAll(`input[name="${filterSlug}[]"]`).forEach(checkbox => {
      checkbox.checked = false;
    });
  },

  resetAllFilters() {
    Object.keys(this.selections).forEach(filterSlug => {
        this.reset(filterSlug);
    });
    this.submitForm();
  },

  updateAllResetButtonVisibility() {
    Object.keys(this.selections).forEach(filterSlug => this.updateResetButtonVisibility(filterSlug));
  },

  anyFiltersApplied() {
    return Object.values(this.selections).some(selection => selection.length > 0);
  },

  updateResetButtonVisibility(filterSlug) {
    this.$nextTick(() => {
      const resetButton = this.$refs[`reset-${filterSlug}`];
      if (resetButton) {
        resetButton.classList.toggle('hidden', !this.hasSelections(filterSlug));
      }
    });
  },

  hasSelections(filterSlug) {
    return this.selections[filterSlug] && this.selections[filterSlug].length > 0;
  },

  fetchResultsCount() {
    // @DEV: Could be optimized, currently we don't want the scoped
    // filters to affect the query string, but we do want it to affect
    // the results count. So we're merging the selections and scoped
    const selections = { ...this.selections, ...this.scoped };
    const payload = {};

    // Convert the selection + scoped combo to an object suitable for fetch
    for (const selection of Object.entries(selections)) {
      let [key, value] = selection;
      if (value.length > 0) {
        payload[key] = value
      }
    }

    if (this.keywords.length) {
      payload.keywords = this.keywords
    }

    fetch('/actions/ttec-digital/thoughts-filter/count', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
      .then(response => response.json())
      .then(data => {
        this.resultsCount = data.count;
        if (data.count === 0) {
          this.resultsCountLabel = 'No Results';
        } else if (data.count === 1) {
          this.resultsCountLabel = 'Show 1 Result';
        } else if (data.count > 100) {
          this.resultsCountLabel = 'Show 100+ Results';
        } else {
          this.resultsCountLabel = 'Show ' + data.count + ' Results';
        }
        if (data.noResults) {
          this.disableRelevantCheckboxes(data.noResults);
        }
        this.state = 'ready';
      })
      .catch(error => {
        console.error('Error fetching count:', error);
        this.state = 'error';
      });
  },

  disableRelevantCheckboxes(slugs) {
    const cbs = document.getElementsByClassName('reactive-checkbox');

    for (let i = 0; i < cbs.length; i++) {
      let cb = cbs.item(i);
      let slug = cb.value;
      if (slugs.includes(slug)) {
        cb.disabled = true;
        cb.parentNode.classList.add('text-[#CCCCCC]');
      } else {
        cb.disabled = false;
        cb.parentNode.classList.remove('text-[#CCCCCC]');
      }
    }
  },

  updateKeywords(value) {
    this.keywords = value;
  },

  submitForm() {
    if (this.modalId) {
      try {
        MicroModal.close(this.modalId);
      } catch (error) {
        // If no modal was ever opened, MicroModal might error out
      }
    }

    // Construct the URL for state
    const params = new URLSearchParams();
    for (const selection of Object.entries(this.selections)) {
      let [key, value] = selection;
      if (value.length > 0) {
        params.set(key, typeof value == "object" ? value.join(',') : value);
      }
    }

    // Throw the search in as well
    if (this.keywords.length > 0) {
      params.set('keywords', this.keywords)
    }

    history.pushState({}, '', decodeURIComponent(`${window.location.pathname}?${params}`));

    // Finally, trigger the whole sprig thing.
    htmx.trigger('#' + this.el.id, 'submit');
  }
});
